// pages/LuxotticaUnauthorizedPage.jsx
import { useNavigate } from 'react-router-dom';
import UnauthorizedPage from '@/components/UnauthorizedPage';
import { buildPath } from '@/utils/routeBuilder';

const IconicUnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <UnauthorizedPage
      projectName="Iconic"
      onGoToDashboard={() => navigate(buildPath('/iconic'))}
      onSignInDifferent={() => navigate(buildPath('/iconic/login'))}
      brandColor="blue"
    />
  );
};

export default IconicUnauthorizedPage;